import React, { useState, useEffect, useContext } from 'react';
import { CanvasContext } from "../contexts/CanvasContext";
import Layer from './Layer';
import BackgroundGroup from './BackgroundGroup';
import PrimaryGroup from './PrimaryGroup';
import SecondaryGroup from './SecondaryGroup';
import TextGroup from './TextGroup';
import "../styles/canvas.css";

import {
    Box,
    Stack,
    Typography,
    Button,
    Menu,
    MenuItem,
} from "@mui/material";

const LayersPanel = ({
    handleAltChange,
}) => {
    const { 
        layers,
        groups, setGroups, layersLoading, generateGroups,
    }
        = useContext(CanvasContext);


    const [anchorEl, setAnchorEl] = useState(null);
    const renderTextGroups = () => renderGroups("text", TextGroup, groups);
    const renderPrimaryGroups = () => renderGroups("primary", PrimaryGroup, groups);
    const renderSecondaryGroups = () => renderGroups("secondary", SecondaryGroup, groups);
    const renderBackgroundGroups = () => renderGroups("background", BackgroundGroup, groups);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const getNextGroupIDs = (groups) => {

        const nextGroupIDs = {};

        const roles = ['primary', 'secondary', 'default', 'background', 'text']; // Add all possible roles here

        roles.forEach(role => {
            if (!groups[role]) {
                nextGroupIDs[role] = '0';
                console.log(`Role: ${role}, Next Group ID: ${nextGroupIDs[role]}`); // Debugging log
                return;
            }

            const groupKeys = Object.keys(groups[role]);
            console.log(`Role: ${role}, Group Keys: ${groupKeys}`); // Debugging log

            const groupNumbers = groupKeys.map(key => parseInt(key, 10));
            console.log(`Role: ${role}, Group Numbers: ${groupNumbers}`); // Debugging log

            const maxGroupNumber = groupNumbers.length > 0 ? Math.max(...groupNumbers) : -1; // -1 ensures that if no groups exist, the next ID will be 0

            nextGroupIDs[role] = `${maxGroupNumber + 1}`;
            console.log(`Role: ${role}, Next Group ID: ${nextGroupIDs[role]}`); // Debugging log
        });

        return nextGroupIDs;
    };


    const renderGroups = (groupType, GroupComponent, groups) => {

        if (!layers || !groups || !groups[groupType] ) {
            return null;
        }

        return Object.keys(groups[groupType]).map(groupID => {

            const groupLayers = groups[groupType][groupID];


            return (
                <GroupComponent
                    key={`${groupType}-${groupID}`}
                    groupLayers={groupLayers}
                    // handleAltChange={handleAltChange}
                    groupID={groupID} // Pass groupID as a prop
                    role={groupType} // Pass role as a prop
                />
            );
        });
    };

    const addGroup = (groupType) => {
        const nextGroupID = getNextGroupIDs(groups)[groupType];

        const updatedGroups = { ...groups };

        if (!updatedGroups[groupType]) {
            updatedGroups[groupType] = {};
        }
        updatedGroups[groupType][nextGroupID] = [];

        setGroups(updatedGroups);

    };

    const addTextGroup = () => { addGroup("text") };
    const addBackgroundGroup = () => { addGroup("background") };
    const addPrimaryGroup = () => { addGroup("primary") };
    const addSecondaryGroup = () => { addGroup("secondary") };


    if (layersLoading) {
        return <p>Loading layers...</p>;
    } else {
        return (
            <div
                id="layers-panel">
                <Stack direction="row">
                    <Typography variant="h5" gutterBottom>
                        Layers
                    </Typography>
    
                    <Stack direction="row" sx={{ right: "0px", position: "absolute", marginRight: "1em" }}>
    
                        <Button
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleMenuClick}
                            variant="outlined"
                            color="secondary"
                        >
                            +
                        </Button>
                        <Menu
                            id="simple-menu"
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            anchorEl={anchorEl}
                        >
                            <MenuItem onClick={addTextGroup} >Add Text Group</MenuItem>
                            <MenuItem onClick={addBackgroundGroup}>Add Background Group</MenuItem>
                            <MenuItem onClick={addPrimaryGroup}>Add Primary Group</MenuItem>
                            <MenuItem onClick={addSecondaryGroup}>Add Secondary Group</MenuItem>
    
                        </Menu>
                    </Stack>
                </Stack>
    
                {renderTextGroups()}
                {renderBackgroundGroups()}
                {renderPrimaryGroups()}
                {renderSecondaryGroups()}
    
                <Box sx={{ width: "90%", float: "right", height: "100%" }}>
    
                    {layers && (
    
                        <div
                        // onDragOver={handleDragOver}
                        // onDrop={(e) => handleDrop(e, 'text')}
                        >
                            {/* <Typography variant="h6">Default</Typography> */}
                            {layers.filter(layer => !layer.role).map((layer) => (
                                <Layer
                                    key={layer.id}
                                    layer={layer}
                                // onAltChange={handleAltChange}
                                // onClick={(event) => handleLayerClick(layer, event)}
                                // onDragStart={(e) => handleDragStart(e, layer)}
                                // onDragEnter={(e) => handleDragEnter(e, 'default')}
                                />
                            ))}
                        </div>
                    )}
    
                </Box>
    
    
            </div>
        );

    }


    
};


export default LayersPanel;